export function inViewport(element, offset = 0) {

  const { 
    top, 
    right, 
    bottom, 
    left,
  } = element.getBoundingClientRect();

  return bottom > offset
      && right > offset
      && window.innerWidth - left > offset
      && window.innerHeight - top > offset;
}

export function throttle(fn, delay, atleast) {
  let timer = null;
  let previous = null;

  return () => {
    const now = +new Date();

    if (!previous) previous = now;
    if (atleast && now - previous > atleast) {
      fn();
      previous = now;
      clearTimeout(timer);
    } else {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn();
        previous = null;
      }, delay);
    }

  };
}

export function isBodyFixed() {
  const body = document.body;
  
  if (body.classList.contains('overflow_hidden') === true) {
    body.classList.remove('overflow_hidden');
  } else {
    body.classList.add('overflow_hidden');
  }
}

export function formatNumber(val) {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function addUrlQueryValue(value) {
  if (history.pushState) {
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${value}`;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

export function formatMMSS(secs) {
  const secNum = parseInt(secs, 10);
  const hours = Math.floor(secNum / 3600) % 24;
  const minutes = Math.floor(secNum / 60) % 60;
  const seconds = secNum % 60;

  return [hours, minutes, seconds].map((v) => { return v < 10 ? `0${v}` : v; })
                           .filter((v, i) => {
                             return v !== '00' || i > 0;
                           })
                           .join(':');
}

export function showPages(pageNum, total) {
  const page = +pageNum;
  // 轉字串
  let str = isNaN(page) ? page : page.toString();

  for (let i = 1; i <= 3; i++) {
    if (page - i > 1) {
      str = `${page - i} ${str}`;
    }
    if (page + i < total) {
      str = `${str} ${page + i}`;
    }
  }

  if (page - 4 > 1) {
    str = `ellipsis ${str}`;
  }

  if (page > 1) {
    str = `1 ${str}`;
  }

  if (page + 4 < total) {
    str = `${str} ellipsis`;
  }

  if (page < total) {
    str = `${str} ${total}`;
  }
  return str;
}

export function getEmailName(email) {
  let name = '';
  if (typeof email === 'string' && email.indexOf('@') !== -1) {
    name = email.split('@')[0];
  }
  return name;
}



// WEBPACK FOOTER //
// ./src/help/index.js